import { render, staticRenderFns } from "./Filial.vue?vue&type=template&id=3b794a37&scoped=true"
import script from "./Filial.vue?vue&type=script&lang=js"
export * from "./Filial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b794a37",
  null
  
)

export default component.exports